import { defineStore } from 'pinia';
import { streamTrademarks } from "@/services/trademarks.js";
import { streamDocketing } from "@/services/trademark_docketing.js";
import { ref } from "vue";

export const useTrademarkStore = defineStore('trademark', {
  state: () => ({
    firmId: null,
    userId: null,
    the_trademarks: [],
    the_dockets: [],
    tm_loaded: false,
    docket_loaded: false,
    unsubscribeTm: null,
    unsubscribeDocketing: null,
    trademark_columns:[
      {
        name: "Serial No.",
        sortStatus: "a",
        checked: true,
        fieldName: "serialNumber",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Registration No.",
        sortStatus: "a",
        checked: true,
        fieldName: "registrationNumber",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Mark",
        sortStatus: "a",
        checked: true,
        fieldName: "wordMark",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "IC",
        sortStatus: "a",
        checked: true,
        fieldName: "internationalClass",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Applicant",
        sortStatus: "a",
        checked: true,
        fieldName: "applicantName",
        filterStr: "",
        filterFlag: false,
      },
    ],
    the_docket_columns: [
      {
        name: "Serial No.",
        sortStatus: "a",
        checked: true,
        fieldName: "serialNumber",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Registration No.",
        sortStatus: "a",
        checked: true,
        fieldName: "registrationNumber",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Mark",
        sortStatus: "a",
        checked: true,
        fieldName: "wordMark",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Task",
        sortStatus: "a",
        checked: true,
        fieldName: "title",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Deadline",
        sortStatus: "a",
        checked: true,
        fieldName: "deadline",
        filterStr: "",
        filterFlag: false,
      },
      {
        name: "Event Type",
        sortStatus: "a",
        checked: true,
        fieldName: "eventType",
        filterStr: "",
        filterFlag: false,
        filterOptions: [],
      },
      {
        name: "Status",
        sortStatus: "a",
        checked: true,
        fieldName: "status",
        filterStr: "",
        filterFlag: false,
        filterOptions: [],
      },
    ],
    showCompleted: false,
    showDead: false,
    trademark_sort: null,
    docket_sort: null,
  }),
  getters: {
    filteredSortedTrademarks: (state) => {
      let filterColumns = state.trademark_columns.filter((c) => { return c.filterFlag == true })
        .map((c) => {
          if (c.filterOptions) {
            c.filterArray = c.filterOptions.reduce((optArray, opt) => {
              if (opt.value) {
                optArray.push(opt.label);
              }
              return optArray;
            }, []);
          }
          return c;
        });

      let filteredTms = []

      if (filterColumns.length == 0) {
        filteredTms = state.the_trademarks.filter((x) => {
          if (state.showDead) {
            return !x.alive;
          } else {
            return x.alive;
          }
        });
      } else {
        filteredTms = state.the_trademarks.filter((x) => {
          if (state.showDead == !!x.alive) {
            return false;
          }
          for (const filterColumn of filterColumns) {
            var field_name = filterColumn.fieldName;

            let value = "";
            if (Array.isArray(x[field_name])) {
              value = x[field_name].join(" ");
            }
            else {
              value = x[field_name];
            }
            if (filterColumn.filterArray && !filterColumn.filterArray.includes(value)) {
              return false;
            } else {
              if (!value || !value.toUpperCase().includes(filterColumn.filterStr.toUpperCase())) {
                return false;
              }
            }
          }
          return true;
        });
      }
      let localSortColumn = state.trademark_sort;
      if (localSortColumn) {
        return filteredTms.toSorted(function (a, b) {
          var keyA = "";
          var keyB = "";
          if (Array.isArray(a[localSortColumn.fieldName])) {
            keyA = a[localSortColumn.fieldName][0] ? a[localSortColumn.fieldName][0] : "";
            keyB = b[localSortColumn.fieldName][0] ? b[localSortColumn.fieldName][0] : "";
          }
          else {
            keyA = a[localSortColumn.fieldName] ? a[localSortColumn.fieldName] : "";
            keyB = b[localSortColumn.fieldName] ? b[localSortColumn.fieldName] : "";
          }
          if (localSortColumn.sortStatus == "a") {
            return keyA.localeCompare(keyB);
          } else {
            return keyB.localeCompare(keyA);
          }
        });
      } else {
        return filteredTms;
      }
    },
    filteredSortedDockets: (state) => {
      let filterColumns = state.the_docket_columns.filter((c) => { return c.filterFlag == true })
        .map((c) => {
          if (c.filterOptions) {
            c.filterArray = c.filterOptions.reduce((optArray, opt) => {
              if (opt.value) {
                optArray.push(opt.label);
              }
              return optArray;
            }, []);
          }
          return c;
        });

      let filteredDockets = []

      if (filterColumns.length == 0) {
        filteredDockets = state.the_dockets.filter((x) => {
          if (state.showCompleted) {
            return x.status == "Completed";
          } else {
            return x.status != "Completed";
          }
        });
      } else {
        filteredDockets = state.the_dockets.filter((x) => {

          if (state.showCompleted != (x.status == "Completed")) {
            return false;
          }
          for (const filterColumn of filterColumns) {
            var field_name = filterColumn.fieldName;

            let value = "";
            if (Array.isArray(x[field_name])) {
              value = x[field_name].join(" ");
            }
            else {
              value = x[field_name];
            }

            if (filterColumn.filterArray && !filterColumn.filterArray.includes(value)) {
              return false;
            } else {
              if (!value || !value.toUpperCase().includes(filterColumn.filterStr.toUpperCase())) {
                return false;
              }
            }
          }
          return true;
        });
      }
      let localSortColumn = state.docket_sort;
      if (localSortColumn) {
        return filteredDockets.toSorted(function (a, b) {
          var keyA = "";
          var keyB = "";
          if (Array.isArray(a[localSortColumn.fieldName])) {
            keyA = a[localSortColumn.fieldName][0] ? a[localSortColumn.fieldName][0] : "";
            keyB = b[localSortColumn.fieldName][0] ? b[localSortColumn.fieldName][0] : "";
          }
          else {
            keyA = a[localSortColumn.fieldName] ? a[localSortColumn.fieldName] : "";
            keyB = b[localSortColumn.fieldName] ? b[localSortColumn.fieldName] : "";
          }
          if (localSortColumn.sortStatus == "a") {
            return keyA.localeCompare(keyB);
          } else {
            return keyB.localeCompare(keyA);
          }
        });
      } else {
        return filteredDockets;
      }
    },
    tm_columns: (state) => state.trademark_columns,
    tm_sort_column: (state) => state.trademark_sort,
    docket_columns: (state) => state.the_docket_columns,
    docket_sort_column: (state) => state.docket_sort,
  },
  actions: {


    loadData(firmId, userId) {
      if (!firmId || !userId) {
        throw new Error('firm and user required');
      }
      const columnChecks = JSON.parse(localStorage.getItem("trademark_docketing_columns_checked"));
      if (columnChecks && Array.isArray(columnChecks)) {
        this.the_docket_columns.forEach((c, index) => { c.checked = columnChecks[index]; });
      }
      const tmcolumnChecks = JSON.parse(localStorage.getItem("trademark_columns_checked"));
      if (tmcolumnChecks && Array.isArray(tmcolumnChecks)) {
        this.trademark_columns.forEach((c, index) => { c.checked = tmcolumnChecks[index]; });
      }
      if (firmId != this.firmId || userId != this.userId) {
        //get rid of loaded at code. maybe need error handling to reset when the listener fails.
        this.tm_loaded = false;
        this.docket_loaded = false;
        this.firmId = firmId;
        this.userId = userId;
        if (this.unsubscribeTm && typeof this.unsubscribeTm === 'function') {
          this.unsubscribeTm();
        }
        if (this.unsubscribeDocketing && typeof this.unsubscribeDocketing === 'function') {
          this.unsubscribeDocketing();
        }
        this.unsubscribeTm = streamTrademarks(this.firmId, this.tradeMarkSnapper);
        this.unsubscribeDocketing = streamDocketing(this.firmId, this.docketSnapper);
        //TODO do unsubscribe/resubscribe on errors. maybe on leaving the page and resubscribe on load?
        
      }
    },
    docketSnapper(snapshot) {
      const all_dockets = ref([]);
      all_dockets.value = snapshot.docs.map((doc) => {
        const data = doc.data();
        if (data.status === "Overdue") {
          data.status = "To Do";
        }
        return data;
      });
      this.the_dockets = all_dockets;
      this.docket_loaded = true;
      this.updateFilterOptions();
    },
    tradeMarkSnapper(snapshot) {
      const tms = []
      snapshot.forEach((tm) => {
        tms.push(tm.data());
      });
      this.tm_loaded = true;
      this.the_trademarks = tms;
    },
    updateTmColumns(newColumns) {
      this.trademark_columns = newColumns;
    },
    updateDocketColumns(newColumns) {
      this.the_docket_columns = newColumns;
    },
    setShowDead(newVal) {
      this.showDead = !!newVal;
    },
    setShowCompleted(newVal) {
      this.showCompleted = !!newVal;
      this.updateFilterOptions();
    },
    updateTmSortColumn(newVal) {
      this.trademark_sort = newVal;
    },
    updateDocketSort(newVal) {
      this.docket_sort = newVal;
    },
    updateFilterOptions() {
      console.log("Updating filter options...");
      this.updateEventTypeFilterOptions();
      this.updateStatusFilterOptions();
    },

    updateEventTypeFilterOptions() {
      // Get unique eventTypes from docketingItems
      if (!this.showCompleted) {
        const pendingItems = this.the_dockets.filter(item => item.status != "Completed");
        const uniqueEventTypes = [...new Set(
          pendingItems
            .map(item => item.eventType)
            .filter(eventType => eventType) // filter out null/undefined
        )].sort();

        // Find the eventType column and update its filterOptions
        const eventTypeColumn = this.the_docket_columns.find(col => col.fieldName === 'eventType');
        if (eventTypeColumn) {
          eventTypeColumn.filterOptions = uniqueEventTypes.map(eventType => ({
            label: eventType,
            value: true,
            count: pendingItems.filter(item => item.eventType === eventType).length
          }));
        }
      } else {
        const completedItems = this.the_dockets.filter(item => item.status == "Completed");
        const uniqueEventTypes = [...new Set(
          completedItems
            .map(item => item.eventType)
            .filter(eventType => eventType) // filter out null/undefined
        )].sort();

        // Find the eventType column and update its filterOptions
        const eventTypeColumn = this.the_docket_columns.find(col => col.fieldName === 'eventType');
        if (eventTypeColumn) {
          eventTypeColumn.filterOptions = uniqueEventTypes.map(eventType => ({
            label: eventType,
            value: true,
            count: completedItems.filter(item => item.eventType === eventType).length
          }));
        }
      }
    },

    updateStatusFilterOptions() {
      if (!this.showCompleted) {
        const pendingItems = this.the_dockets.filter(item => item.status != "Completed");
        const uniqueStatusTypes = [...new Set(
          pendingItems
            .map(item => item.status)
            .filter(status => status && status !== "Overdue") // filter out null/undefined and "Overdue"
        )].sort();

        // Find the status column and update its filterOptions
        const statusColumn = this.the_docket_columns.find(col => col.fieldName === 'status');
        if (statusColumn) {
          statusColumn.filterOptions = uniqueStatusTypes.map(status => ({
            label: status,
            value: true,
            count: pendingItems.filter(item => { 
              if (status === "To Do" && (item.status === "Overdue" || item.status === "To Do")) {
                return true;
              }
              if (status === "Overdue") {
                return false;
              }
              return item.status === status;
            }).length
          }));
        }
      } else {
        const statusColumn = this.the_docket_columns.find(col => col.fieldName === 'status');
        if (statusColumn) {
          statusColumn.filterOptions = [
            { label: "Completed", value: true, count: this.the_dockets.filter(item => item.status == "Completed").length }
          ];
        }
      }
    }
  },
});


